var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-products grid",
      class: [{ "--plp-exclusive": _vm.isPlpExclusive }],
    },
    [
      _vm._l(_vm.productsAndBanners, function (slot, i) {
        return [
          slot.type === _vm.BANNER && !_vm.isPlpExclusive
            ? _c("v-runtime-template", {
                key: i,
                ref: "banner",
                refInFor: true,
                class: _vm.getBannerColumn(slot),
                attrs: { template: slot.template },
              })
            : slot.type !== _vm.BANNER || !_vm.isPlpExclusive
            ? _c("rb-product-tile", {
                key: slot.sku,
                ref: "tile",
                refInFor: true,
                class: _vm.productTileClass,
                attrs: {
                  index: i,
                  "data-element-id": _vm.setDataElementId(i),
                  product: slot.product,
                  "is-editorial": false,
                  "is-plp-exclusive": _vm.isPlpExclusive,
                  "prevent-lazy": _vm.hasPreventLazy(i),
                  "is-inside-search-panel": _vm.isInsideSearchPanel,
                  "is-in-view-port-panel": _vm.isTileInViewPortSearch(
                    _vm.setDataElementId(i)
                  ),
                  "handle-wishlist-modal": _vm.handleWishlistModal,
                },
              })
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }